import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=f32273e6&scoped=true"
import script from "./SpeechToText.vue?vue&type=script&lang=js"
export * from "./SpeechToText.vue?vue&type=script&lang=js"
import style0 from "./SpeechToText.vue?vue&type=style&index=0&id=f32273e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32273e6",
  null
  
)

export default component.exports